import { IContextualMenuItem, IContextualMenuItemProps } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { RootState } from "../../../src/taskpane/redux";
import { getItemWebViewUrl, getSPListItemWebUrl } from "../../../src/taskpane/services/GraphService";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { OpenFolder20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/OpenFolder20Regular";

export function useMenuItem_CurrentLocation(
  isEnabled: boolean,
  isInOneDrive: boolean
) {
  const languageStrings = React.useContext(LanguageContext);

  const { workingDirectories, oneDriveRootDetails } = useSelector((state: RootState) => state.workingDirectories);
  const currentDirectory = useSelector((state: RootState) => workingDirectories?.at(-1));
  const allowOpenInSharePoint = useSelector((state: RootState) =>
    (state.user.tenantAllowOpenInSharePoint ?? true) && !workingDirectories?.some(dir => dir?.type === ComponentTypes.Docubird)
  );

  const openLocationInBrowser = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
    (async () => {
      if (isInOneDrive && !currentDirectory.directory) {
        window.open(currentDirectory.webUrl);
      }
      else {
        const driveId = !isInOneDrive ? (!currentDirectory.parentId ? currentDirectory.id : currentDirectory.parentId) : oneDriveRootDetails.driveId;

        let itemId: string;
        if (isInOneDrive) {
          itemId = currentDirectory.id;
        }
        else {
          itemId = currentDirectory.parentId && currentDirectory.id;
        }

        let url: string;
        try {
          if (workingDirectories && workingDirectories.some(x => x.type === ComponentTypes.SharePointList)) {
            if (!itemId && currentDirectory.serverRelativePath) {
              url = new URL(currentDirectory.webUrl).origin + currentDirectory.serverRelativePath;
            }
            else {
              url = await getSPListItemWebUrl(await authModule.getGraphAccessToken(), currentDirectory.siteId, driveId, itemId)
            }
          }
          else {
            url = await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, itemId)
          }
        } catch (error) {
          // Ignore
        }

        if (url) {
          window.open(url);
        }
      }
    })();
  }, [workingDirectories, currentDirectory, isInOneDrive, oneDriveRootDetails]);

  const menuItem_CurrentLocation = React.useMemo(() => {
    const shouldShowMenuItem = isEnabled && allowOpenInSharePoint;

    if (shouldShowMenuItem) {
      return {
        key: "openCurrentLocation",
        // iconProps: { iconName: !isInOneDrive ? "SharepointLogo" : "OneDriveLogo" },
        iconProps: {},
        text: !isInOneDrive ? `${languageStrings.OpenIn} SharePoint` : `${languageStrings.OpenIn} OneDrive`,
        onClick: openLocationInBrowser,
        onRenderIcon: (props: IContextualMenuItemProps) => {
          // return !isInOneDrive
          //   ? <img src={BrandIcons.SharePoint20} style={{ height: 20, width: 20, marginLeft: 2, marginRight: 2 }} />
          //   : <img src={BrandIcons.OneDrive20} style={{ height: 20, width: 20, marginLeft: 2, marginRight: 2 }} />;
          return <OpenFolder20Regular className={menuItemIconStyles} />
        },
      };
    }

    return null;

  }, [
    isEnabled,
    allowOpenInSharePoint,
    isInOneDrive,
    languageStrings,
    openLocationInBrowser
  ]);

  return {
    menuItem_CurrentLocation
  };
}